export default __webpack_public_path__ + "static/media/ring.95b79387.mp3";